module.exports = __webpack_public_path__ + "static/leslie-heart-head-b77e2d68a8bf701353040f9da4b80157.png";